<template>
  <div>
    <base-header class="bg-vg-gradient pb-6 pb-8 pt-5 pt-md-8"></base-header>
    <div class="container-fluid mt--9">
      <div class="row">
        <div class="col-xl-12">
          <div class="card shadow">
            <div class="card-header border-0">
              <div class="row align-items-center">
                <div class="col">
                  <h3 class="mb-0">Projeler</h3>

                </div>
                <div class="col-lg-3 col-xs-12 text-right">
                  <el-dropdown class="form-control-alternative">
                    <el-button id="see-status-button" type="default" style="border: none!important"
                               class="text-black-50">
                      Görüntülenme Durumu <i class="el-icon-arrow-down el-icon--right"></i>
                    </el-button>
                    <el-dropdown-menu slot="dropdown">
                      <el-dropdown-item>
                        <router-link style="color:unset"
                                     :to="{ path: '/admin/ideas/all' }">Hepsi
                        </router-link>
                      </el-dropdown-item>

                      <el-dropdown-item>
                        <router-link style="color:unset"
                                     :to="{ path: '/admin/ideas/deleted' }">
                          Silinen Projeler
                        </router-link>
                      </el-dropdown-item>
                    </el-dropdown-menu>
                  </el-dropdown>
                </div>

              </div>
            </div>

            <div class="table-responsive" v-loading="loading">
              <base-table thead-classes="thead-light"
                          :data="ideas"
                          v-if="ideas != null "
              >
                <template slot="columns">
                  <th>Kullanıcı</th>
                  <th>E-Posta</th>
                  <th>Tarihi</th>
                  <th>Durum</th>
                  <th>İşlemler</th>
                </template>
                <template slot-scope="{row}">
                  <th scope="row">
                    <div class="media align-items-center">
                      <a href="#" class="avatar rounded-circle mr-3">
                        <img :src="'https://vizyonergenc.com/storage/'+row.users.avatar"/>
                      </a>
                      <div class="media-body">
                        <span class="name mb-0 text-sm">{{ row.users.name }}</span>
                      </div>
                    </div>
                  </th>
                  <td>{{ row.users.email }}</td>
                  <td class="first_follow_date">{{ row.created_at }}</td>
                  <td>
                    <badge v-if="row.status===1" class="badge-dot mr-4" type="success">
                      <i class="bg-success"></i>
                      <span class="status">Aktif</span>
                    </badge>
                    <badge v-else class="badge-dot mr-4" type="danger">
                      <i class="bg-danger"></i>
                      <span class="status">Pasif</span>
                    </badge>
                  </td>
                  <td>
                    <button v-if="row.operating == null" v-on:click="takeIdea(row.id)" class="btn btn-sm btn-success">
                      <span>Üstüne Al</span>
                    </button>
                    <button v-else class="btn btn-sm btn-danger">
                      <span>{{ row.operators.name }}</span>
                    </button>
                    <router-link :to="{ path: '/admin/ideas/detail/'+row.id}" class="btn btn-sm btn-success"><i
                        class="fas fa-external-link-alt"></i>
                      <span>Detay</span>
                    </router-link>
                  </td>
                </template>
              </base-table>
            </div>
            <div class="card-footer py-4 d-flex justify-content-between align-items-center">
              <small class="mb-0">Toplam: {{ total }}</small>
              <base-pagination v-model="currentPage" :total="total"></base-pagination>
            </div>
          </div>

        </div>
      </div>
    </div>
  </div>
</template>
<script>
import * as axios from "axios";

export default {
  name: 'IdeaList',
  data() {
    return {
      vm: null,
      loading: true,
      ideas: [],
      followers: null,
      offset: 20,
      limit: 10,
      pageSizes: [5, 10, 15, 30, 50],
      total: 0,
      filterForm: {},
      currentPageSize: 10,
      currentPage: 1,
      alphabeticalSortingValue: "",
      list_status: null,
      options: [{
        value: 'asc',
        label: 'A dan Z ye'
      }, {
        value: 'desc',
        label: 'Z den A ya'
      }]
    };
  },
  async mounted() {
    await this.getIdeasList();
  },

  async created() {
    let fullpath = this.$route.fullPath;
    await this.handleRouteChange(fullpath);

  },
  beforeRouteUpdate(to, from, next) {
    this.handleRouteChange(to.path);
    next();
  },
  watch: {
    currentPage: {
      handler: "paginate",
      immediate: true
    }
  },
  methods: {
    async handleRouteChange(fullpath) {
      this.loading = true;
      let status = this.getExactRoute(fullpath);
      if (status == "all") {
        this.list_status = "0";
      } else if (status == "deleted") {
        this.list_status = "1";
      } else {
        this.list_status = null;
      }
      this.limit = this.currentPageSize;
      await this.getIdeasList();
      this.loading = true;
      await this.prepareListData();
    },
    getExactRoute(path) {
      let arr = path.split('/');
      return arr[arr.length - 1];
    },
    async getIdeasList() {
      let data = {
        offset: this.offset,
        limit: this.limit,
        list_status: this.list_status
      }
      axios.post('admin/ideas', data).then(response => {
        console.log(response.data)
        this.loading = false;
        this.ideas = response.data.results;
        this.total = response.data.new_request_requirements.total;
        this.followers = response.data.results;
        return response.data;
      })
          .catch(error => {
            this.loading = false;
            this.$notify.error({
              title: 'Bir hata meydana geldi',
              message: error.response.data.join(' ')
            });
          })
    },
    async prepareListData() {
      this.loading = true;
      await this.getIdeasList();
      this.loading = false;
    },
    handleSizeChange(val) {
      this.currentPageSize = val;
      this.currentPage = 1;
      this.paginate();
    },
    handleCurrentChange(val) {
      this.currentPage = val;
      this.paginate();
    },
    async paginate() {
      this.offset = (this.currentPage - 1) * this.currentPageSize;
      this.limit = this.currentPageSize;
      this.loading = true;
      await this.prepareListData();
      this.loading = false;
    },
    clearPagination() {
      this.currentPage = 1;
      this.offset = (this.currentPage - 1) * this.currentPageSize;
    },

    companyDetail(company_id) {
      this.$router.push("/admin/company/detail/" + company_id);

    },
    takeIdea(id) {
      this.loading = true;
      let data = {id: id};
      // eslint-disable-next-line no-unused-vars
      axios.post('admin/ideas/take-idea', data).then(response => {
        this.$notify.success({
          title: 'Başarılı',
          message: 'Proje başarıyla üstünüze alındı'
        });
        this.getIdeasList();
      })
          .catch(error => {
            this.$notify.error({
              title: 'Bir hata meydana geldi',
              message: error.response.data.join(' ')
            });
          })
    }

  }
};
</script>

<style>
.pagi {
  color: green !important;

}
</style>
